export default __webpack_public_path__ + "static/media/criterios.bdde6d63.png";